import React from "react";

const DonateLeave = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M13.803 17.396h3.11a6.447 6.447 0 0 1 6.45 6.444l-10.035-.001.002 1.433 11.467-.001v-1.43c0-1.55-.456-3.012-1.27-4.298l4.137.001a7.168 7.168 0 0 1 6.474 4.083C30.748 28.096 25.258 31 19.064 31c-3.959 0-7.312-.846-10.035-2.327L9.03 15.35c1.785.255 3.42.98 4.772 2.046Zm-7.64-3.58c.735 0 1.34.553 1.423 1.265l.01.166v12.89c0 .79-.642 1.431-1.434 1.431H3.296a1.433 1.433 0 0 1-1.434-1.432V15.248c0-.79.642-1.432 1.434-1.432h2.866ZM19.99 6.05l.507.506.507-.506a3.586 3.586 0 0 1 5.068 0 3.577 3.577 0 0 1 0 5.062l-5.575 5.57-5.575-5.57a3.577 3.577 0 0 1 0-5.062 3.586 3.586 0 0 1 5.068 0Z"
            fill={fill}
        />
    </svg>
);

export default DonateLeave;
